module.exports = __webpack_public_path__ + "img/link.28cabe88.svg";